import { AxiosResponse } from 'axios';

import API from '../Api';
// Types.
import { loginCustomer } from '../types/customer';

export const oidcAuth = async (token: string, isIframe: boolean): Promise<loginCustomer> => {
  const customer: AxiosResponse<loginCustomer> = await API({
    method: 'get',
    url: `/v1/oidcAuthorization/`,
    headers: {
      code: token,
      iframe: isIframe,
    },
  });

  return customer.data;
};
